import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ConfigService } from '../services/config.service';

/**
 * Guard que protege rotas exclusivas da fase 2.
 * Redireciona para /dashboard quando phase2 não estiver habilitado na config runtime.
 */
export const phase2Guard: CanActivateFn = () => {
  const router = inject(Router);
  const configService = inject(ConfigService);
  const isDebugEnabled = configService.isDebugEnabled();

  if (isDebugEnabled) {
    console.log('[phase2Guard] Validando acesso de fase 2 (aguardando loadConfig)');
  }

  return configService.loadConfig().pipe(
    map((config) => {
      const phase2Enabled = !!config?.phase2;

      if (isDebugEnabled) {
        console.log('[phase2Guard] Resultado após loadConfig', { phase2Enabled });
      }

      if (phase2Enabled) {
        if (isDebugEnabled) {
          console.log('[phase2Guard] Acesso permitido');
        }
        return true;
      }

      if (isDebugEnabled) {
        console.warn('[phase2Guard] Acesso negado. Redirecionando para /dashboard');
      }
      return router.createUrlTree(['/dashboard']);
    }),
    catchError((error) => {
      if (isDebugEnabled) {
        console.warn('[phase2Guard] Erro ao carregar config. Redirecionando para /dashboard', {
          status: error?.status,
          message: error?.message
        });
      }
      return of(router.createUrlTree(['/dashboard']));
    })
  );
};
